var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('h1',{staticClass:"text-h5 grey--text text-uppercase"},[_vm._v(" Dashboard ")])])}]

export { render, staticRenderFns }